<script setup>
import {defineProps, defineEmits, computed} from "vue";
import LinhaDeItem from "./LinhaDeItem/LinhaDeItem.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "tiposDeEquipamento",
    "controlesDesativados"
]);

const emits = defineEmits([
    "update:adicionaItem",
    "update:removeItem",
    "update:descartaItem",
    "update:alteraItem",
    "update:adicionaSubitem",
    "update:removeSubitem",
    "update:descartaSubitem",
    "update:alteraSubitem",
]);

//==================================================================//
//======================= Adiciona Item ============================//
//==================================================================//

const adicionaItem = (update) =>{

    emits('update:adicionaItem',update);

};

//==================================================================//
//======================== Remove Item =============================//
//==================================================================//

const removeItem = (update) =>{

    emits('update:removeItem',update);

};

//==================================================================//
//======================= Descarta Item ============================//
//==================================================================//

const descartaItem = (update) =>{

    emits('update:descartaItem',update);

};

//==================================================================//
//========================= Altera Item ============================//
//==================================================================//

const alteraItem = (update) =>{
    
    emits('update:alteraItem',update);

};

//==================================================================//
//====================== Adiciona Subitem ==========================//
//==================================================================//

const adicionaSubitem = (update) =>{

    emits('update:adicionaSubitem',update);

};

//==================================================================//
//====================== Remove Subitem ============================//
//==================================================================//

const removeSubitem = (update) =>{

    emits('update:removeSubitem',update);

};

//==================================================================//
//===================== Descarta Subitem ===========================//
//==================================================================//

const descartaSubitem = (update) =>{

    emits('update:descartaSubitem',update);

};

//==================================================================//
//======================= Altera Subitem ===========================//
//==================================================================//

const alteraSubitem = (update) => {

    emits('update:alteraSubitem',update);

};

//==================================================================//
//======================== Se Itens Existem ========================//
//==================================================================//

const seItensExistem = computed(()=>{

    return props?.dado?.itens?.length > 0;

});

//==================================================================//
//===================== Se Itens Não Existem =======================//
//==================================================================//

const seItensNaoExistem = computed(()=>{

    return props?.dado?.itens?.length <= 0;

});

</script>

<template>

    <div class="c-table__body">

        <LinhaDeItem v-for="item in props?.dado?.itens"
            v-show="seItensExistem"
            :key="item.id"
            :dado="props?.dado"
            :item="item"
            :tiposDeEquipamento="props?.tiposDeEquipamento"
            :controlesDesativados="props?.controlesDesativados"
            @update:adicionaItem="adicionaItem"
            @update:removeItem="removeItem"
            @update:descartaItem="descartaItem"
            @update:alteraItem="alteraItem"
            @update:adicionaSubitem="adicionaSubitem"
            @update:removeSubitem="removeSubitem" 
            @update:descartaSubitem="descartaSubitem"
            @update:alteraSubitem="alteraSubitem"
        ></LinhaDeItem>

        <div class="c-empty"
            v-show="seItensNaoExistem"
        >
            Nenhum Item Disponível
        </div>
 
    </div>

</template>

<style scoped>

.c-table__body{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
}

.c-empty{
    display: grid;
    grid-column: 1 / -1;
    text-align: center;
    margin: 10px;
}

</style>